// 호스트 셸(상단바·사이드바) 번역 사전 — 모듈 화면의 문구는 각 모듈이 자기 사전으로 번역한다.
// 키를 추가할 때는 ko 에 먼저 넣는다(MessageKey 가 ko 의 키에서 나온다). ja/en 에 빠진 키는 ko 로 보인다.

const ko = {
  // 상단 탭 · 사이드바 메뉴
  'nav.home': '홈',
  'nav.mail': '메일',
  'nav.messenger': '메신저',
  'nav.board': '게시판',
  'nav.oneffice': 'ONEFFICE',
  'nav.videoconf': '화상회의',
  'nav.onechamber': 'ONECHAMBER',
  'nav.finance': '회계관리',
  'nav.basicinfo': '기초정보관리',
  'nav.pjt': '프로젝트관리',
  'nav.hr': '인사관리',
  'nav.ops': '총무관리',
  'nav.tax': '세무신고',
  'nav.sd': '영업관리',
  'nav.mm': '구매관리',
  'nav.pp': '생산관리',
  'nav.log': '물류관리',
  'nav.co': '원가관리',
  'nav.crm': '고객관계관리',
  'nav.erpMain': '메인',
  'nav.aiUsage': 'AI 사용량',
  'nav.settings': '설정',
  'nav.help': '도움말',
  'nav.aiChatTab': 'AI 대화 #{num}',
  'nav.closeTab': '탭 닫기',
  'nav.reload': '새로고침',
  'nav.userMenu': '사용자 메뉴',

  // 사이드바
  'sidebar.newChat': '새 AI 대화',
  'sidebar.pin': '고정하기',
  'sidebar.pinTitle': '사이드바 고정',
  'sidebar.unpin': '사이드바 접기',

  // 상단바 우측
  'top.notifications': '알림',
  'top.portalDefault': '기본 포털',
  'top.portalZeirishi': '세리사무소 포털',
  'top.portalToggle': '{portal} — 눌러서 전환',
  'top.logout': '로그아웃',

  // 프로필 메뉴 — 겸직 소속(회사·부서) 전환
  'aff.current': '현재 소속',
  'aff.switchList': '소속 전환',
  'aff.switchTo': '{label}(으)로 전환',

  // 언어 변경 (KRDS Language switcher)
  'lang.button': '언어 변경',
  'lang.listLabel': '표시 언어 선택',
  'lang.name.ko': '한국어',
  'lang.name.ja': '일본어',
  'lang.name.en': '영어',
  'lang.changed': '표시 언어를 {name}(으)로 변경했습니다',
  'schedule.title': '내 일정',
  'schedule.src.pjt-task': '프로젝트 작업',
  'schedule.src.pjt-todo': '내 업무',
  'schedule.src.hr-leave': '휴가',
  'schedule.src.ops-trip': '출장',
  'schedule.src.hr-attend': '근태 확인',
  'schedule.mod.pjt': '프로젝트관리',
  'schedule.mod.hr': '인사·급여',
  'schedule.mod.ops': '자원관리',
  'schedule.failed': '{names} 일정을 불러오지 못했습니다',
  'schedule.notInstalled': '{names} 모듈이 연결되어 있지 않아 일정에 포함되지 않습니다',
  'schedule.noUser': '로그인 정보에서 사번을 확인하지 못해 일정을 불러올 수 없습니다',
  'schedule.retry': '다시 불러오기',
  'schedule.detail.open': '원래 화면에서 열기',
  'schedule.detail.close': '닫기',
  'schedule.filter': '표시할 일정',
  'schedule.status.late': '지연',
  'schedule.status.sub': '[부담당]',
  'schedule.status.attendAbsent': '결근 확인',
  'schedule.status.attendFix': '근태 정정 대기',
  'schedule.status.attendReview': '근태 확인 필요',
  'schedule.leave.2': '신청',
  'schedule.leave.3': '승인',
  'schedule.leave.5': '변경요청',
  'schedule.leave.6': '취소요청',
  'schedule.trip.1': '발권요청',
  'schedule.trip.2': '변경요청',
  'schedule.trip.3': '기발권',
  'schedule.trip.4': '처리 중',
  'schedule.task.1': '미착수',
  'schedule.task.2': '진행',
  'schedule.task.3': '완료',
  'schedule.task.4': '보류',
  'pane.error.title': '이 화면을 불러오지 못했습니다',
  'pane.error.body': '다른 화면은 그대로 쓸 수 있습니다. 다시 시도해도 같으면 관리자에게 알려 주세요.',
  'pane.error.devHint': '개발 서버라면 공용 킷이 오래된 것일 수 있습니다 — yarn workspace yukimushi-component-fe build 후 개발 서버를 다시 시작하세요.',
  'pane.error.retry': '다시 시도',
  'schedule.widget.sub': '오늘부터 7일 · 내가 맡은 일·휴가·출장',
  'schedule.widget.today': '오늘',
  'schedule.widget.none': '일정 없음',
  'schedule.widget.count': '{n}건',
};

export type MessageKey = keyof typeof ko;

const ja: Partial<Record<MessageKey, string>> = {
  'nav.home': 'ホーム',
  'nav.mail': 'メール',
  'nav.messenger': 'メッセンジャー',
  'nav.board': '掲示板',
  'nav.videoconf': 'ビデオ会議',
  'nav.finance': '会計管理',
  'nav.basicinfo': '基礎情報管理',
  'nav.pjt': 'プロジェクト管理',
  'nav.hr': '人事管理',
  'nav.ops': '総務管理',
  'nav.tax': '税務申告',
  'nav.sd': '販売管理',
  'nav.mm': '購買管理',
  'nav.pp': '生産管理',
  'nav.log': '物流管理',
  'nav.co': '原価管理',
  'nav.crm': '顧客関係管理',
  'nav.erpMain': 'メイン',
  'nav.aiUsage': 'AI 使用量',
  'nav.settings': '設定',
  'nav.help': 'ヘルプ',
  'nav.aiChatTab': 'AI チャット #{num}',
  'nav.closeTab': 'タブを閉じる',
  'nav.reload': '再読み込み',
  'nav.userMenu': 'ユーザーメニュー',

  'sidebar.newChat': '新しい AI チャット',
  'sidebar.pin': '固定する',
  'sidebar.pinTitle': 'サイドバーを固定',
  'sidebar.unpin': 'サイドバーを折りたたむ',

  'top.notifications': 'お知らせ',
  'top.portalDefault': '基本ポータル',
  'top.portalZeirishi': '税理士事務所ポータル',
  'top.portalToggle': '{portal} — クリックで切り替え',
  'top.logout': 'ログアウト',

  'aff.current': '現在の所属',
  'aff.switchList': '所属の切り替え',
  'aff.switchTo': '{label}に切り替え',

  'lang.button': '言語切替',
  'lang.listLabel': '表示言語の選択',
  'lang.name.ko': '韓国語',
  'lang.name.ja': '日本語',
  'lang.name.en': '英語',
  'lang.changed': '表示言語を{name}に変更しました',
  'schedule.title': 'マイスケジュール',
  'schedule.src.pjt-task': 'プロジェクト作業',
  'schedule.src.pjt-todo': 'マイ業務',
  'schedule.src.hr-leave': '休暇',
  'schedule.src.ops-trip': '出張',
  'schedule.src.hr-attend': '勤怠確認',
  'schedule.mod.pjt': 'プロジェクト管理',
  'schedule.mod.hr': '人事・給与',
  'schedule.mod.ops': 'リソース管理',
  'schedule.failed': '{names}の予定を読み込めませんでした',
  'schedule.notInstalled': '{names}モジュールが接続されていないため予定に含まれません',
  'schedule.noUser': 'ログイン情報から社員番号を確認できず、予定を読み込めません',
  'schedule.retry': '再読み込み',
  'schedule.detail.open': '元の画面で開く',
  'schedule.detail.close': '閉じる',
  'schedule.filter': '表示する予定',
  'schedule.status.late': '遅延',
  'schedule.status.sub': '[副担当]',
  'schedule.status.attendAbsent': '欠勤の確認',
  'schedule.status.attendFix': '勤怠訂正待ち',
  'schedule.status.attendReview': '勤怠の確認が必要',
  'schedule.leave.2': '申請',
  'schedule.leave.3': '承認',
  'schedule.leave.5': '変更申請',
  'schedule.leave.6': '取消申請',
  'schedule.trip.1': '発券依頼',
  'schedule.trip.2': '変更依頼',
  'schedule.trip.3': '発券済',
  'schedule.trip.4': '処理中',
  'schedule.task.1': '未着手',
  'schedule.task.2': '進行中',
  'schedule.task.3': '完了',
  'schedule.task.4': '保留',
  'pane.error.title': 'この画面を読み込めませんでした',
  'pane.error.body': '他の画面はそのまま使えます。再試行しても改善しない場合は管理者に連絡してください。',
  'pane.error.devHint': '開発サーバーの場合、共通キットが古い可能性があります — yarn workspace yukimushi-component-fe build の後、開発サーバーを再起動してください。',
  'pane.error.retry': '再試行',
  'schedule.widget.sub': '今日から7日間・担当業務・休暇・出張',
  'schedule.widget.today': '今日',
  'schedule.widget.none': '予定なし',
  'schedule.widget.count': '{n}件',
};

const en: Partial<Record<MessageKey, string>> = {
  'nav.home': 'Home',
  'nav.mail': 'Mail',
  'nav.messenger': 'Messenger',
  'nav.board': 'Board',
  'nav.videoconf': 'Video call',
  'nav.finance': 'Accounting',
  'nav.basicinfo': 'Master data',
  'nav.pjt': 'Projects',
  'nav.hr': 'HR',
  'nav.ops': 'General Affairs',
  'nav.tax': 'Tax filing',
  'nav.sd': 'Sales',
  'nav.mm': 'Purchasing',
  'nav.pp': 'Production',
  'nav.log': 'Logistics',
  'nav.co': 'Cost accounting',
  'nav.crm': 'CRM',
  'nav.erpMain': 'Main',
  'nav.aiUsage': 'AI usage',
  'nav.settings': 'Settings',
  'nav.help': 'Help',
  'nav.aiChatTab': 'AI chat #{num}',
  'nav.closeTab': 'Close tab',
  'nav.reload': 'Reload',
  'nav.userMenu': 'User menu',

  'sidebar.newChat': 'New AI chat',
  'sidebar.pin': 'Pin',
  'sidebar.pinTitle': 'Pin sidebar',
  'sidebar.unpin': 'Collapse sidebar',

  'top.notifications': 'Notifications',
  'top.portalDefault': 'Default portal',
  'top.portalZeirishi': 'Tax office portal',
  'top.portalToggle': '{portal} — click to switch',
  'top.logout': 'Log out',

  'aff.current': 'Current affiliation',
  'aff.switchList': 'Switch affiliation',
  'aff.switchTo': 'Switch to {label}',

  'lang.button': 'Language',
  'lang.listLabel': 'Choose display language',
  'lang.name.ko': 'Korean',
  'lang.name.ja': 'Japanese',
  'lang.name.en': 'English',
  'lang.changed': 'Display language changed to {name}',
  'schedule.title': 'My schedule',
  'schedule.src.pjt-task': 'Project tasks',
  'schedule.src.pjt-todo': 'My to-dos',
  'schedule.src.hr-leave': 'Leave',
  'schedule.src.ops-trip': 'Trips',
  'schedule.src.hr-attend': 'Attendance',
  'schedule.mod.pjt': 'Projects',
  'schedule.mod.hr': 'HR & payroll',
  'schedule.mod.ops': 'Resources',
  'schedule.failed': 'Could not load: {names}',
  'schedule.notInstalled': 'Not connected, so not included: {names}',
  'schedule.noUser': 'Could not identify your employee ID, so the schedule cannot be loaded',
  'schedule.retry': 'Reload',
  'schedule.detail.open': 'Open in original screen',
  'schedule.detail.close': 'Close',
  'schedule.filter': 'Show',
  'schedule.status.late': 'Late',
  'schedule.status.sub': '[Sub]',
  'schedule.status.attendAbsent': 'Absence',
  'schedule.status.attendFix': 'Correction pending',
  'schedule.status.attendReview': 'Needs review',
  'schedule.leave.2': 'Applied',
  'schedule.leave.3': 'Approved',
  'schedule.leave.5': 'Change requested',
  'schedule.leave.6': 'Cancel requested',
  'schedule.trip.1': 'Ticket requested',
  'schedule.trip.2': 'Change requested',
  'schedule.trip.3': 'Ticketed',
  'schedule.trip.4': 'In progress',
  'schedule.task.1': 'Not started',
  'schedule.task.2': 'In progress',
  'schedule.task.3': 'Done',
  'schedule.task.4': 'On hold',
  'pane.error.title': 'Could not load this screen',
  'pane.error.body': 'Other screens still work. If trying again does not help, contact your administrator.',
  'pane.error.devHint': 'On a dev server the shared kit may be stale — run yarn workspace yukimushi-component-fe build, then restart the dev server.',
  'pane.error.retry': 'Retry',
  'schedule.widget.sub': 'Next 7 days · your work, leave and trips',
  'schedule.widget.today': 'Today',
  'schedule.widget.none': 'None',
  'schedule.widget.count': '{n} items',
};

export const MESSAGES: Record<'ko' | 'ja' | 'en', Partial<Record<MessageKey, string>>> = { ko, ja, en };
